<template>
  <div class="more-carousel" :class="{ 'more-carousel--is-home': isHome }">
    <div class="title-wrap">
      <div class="title-wrap__text">
        <section-title :title="title" :deco="deco" :mb="false"/>
        <pr-button v-if="display" class="checkAll" arrow @click="path">查看全部</pr-button>
      </div>
      <div class="title-wrap__step c-prev-next-arrows" v-if="carouselList.length > 4">
        <li :class="`arrow ${prevBtnClassName}`">
          <img src="@/assets/icon/icon_arrow_left.svg" />
        </li>
        <li :class="`arrow ${nextBtnClassName}`">
          <img src="@/assets/icon/icon_arrow_right.svg" />
        </li>
      </div>
    </div>

    <div class="re-carousel" v-if="carouselList.length">
      <swiper
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :space-between="50"
        :slides-per-view="slidePerView"
        :loop="carouselList.length > 4 ? true : false"
        :autoplay="{ autoplay: true, delay: 6500 }"
        :pagination="pagination"
        :navigation="{ prevEl: `.${prevBtnClassName}`, nextEl: `.${nextBtnClassName}` }"
      >
        <swiper-slide v-for="item of carouselList" :key="item.id">
          <div class="carouesel-wrapper">
            <div class="carousel-box" ref="carouselBox">
              <div
                v-if="showImg"
                :style="{
                  borderRadius: `${rounded}px`,
                }"
                class="carousel-box__img-box"
              >
                <div class="carousel-box__img-box__img" :style="{ 'background-image': `url('${item.imgPath}')` }"></div>
              </div>

              <template v-if="item.renderContent">
                <component :is="item.renderContent" :data="item.data" />
              </template>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import SwiperCore, { Pagination, Autoplay, Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import { useRouter } from 'vue-router';
// import 'swiper/modules/pagination/pagination.min.css';
import { useSiteStore } from '@/store/site';
import PrButton from '@/components/Global/PrButton.vue';

SwiperCore.use([Pagination, Autoplay, Navigation]);

export default defineComponent({
  name: 'MoreCarousel',
  components: {
    Swiper,
    SwiperSlide,
    PrButton,
  },
  props: {
    carouselList: {
      type: Array,
      default: () => [],
    },
    deco: {
      type: Boolean,
      default: false,
    },
    showImg: {
      type: Boolean,
      default: true,
    },
    display: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: String,
      default: '0',
    },
    title: {
      type: String,
      default: '',
    },
    prevBtnClassName: {
      type: String,
      default: 'prev-arrow',
    },
    nextBtnClassName: {
      type: String,
      default: 'next-arrow',
    },
    tabletSlidePerView: {
      type: Number,
      default: 4,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
    pagination: {
      default: false,
      // default: () => ({
      //   clickable: true,
      // }),
    },
  },
  setup(props) {
    const router = useRouter();
    const onSwiper = () => {
      // console.log(swiper.activeIndex);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };
    const path = () => {
      router.push({
        name: props.link,
      });
    };
    const siteStore = useSiteStore();

    const slidePerView = computed(() => {
      if (siteStore.deviceType.includes('tablet')) {
        return props.tabletSlidePerView;
      }

      if (siteStore.deviceType.includes('portrait')) {
        return 3;
      }

      return 1;
    });

    return {
      onSwiper,
      onSlideChange,
      slidePerView,
      path,
    };
  },
  data() {
    return {};
  },

  created() {},
});
</script>

<style lang="scss" scoped>
.more-carousel {
  &--is-home {
  }
}
.c-prev-next-arrows {opacity: 0;}
.title-wrap {
  margin-bottom: 50px;
  @include flex(space-between);

  &__text {
    flex: 1;
    display: flex;
  }

  &__step {
    display: none !important;
    @include flex(space-between);
    width: 120px;
    margin-left: 20px;
  }
}

.carouesel-wrapper {
  margin: 30px 0;
  width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  position: relative;
}

.carousel-box {
  width: 100%;
  height: auto;
  position: relative;
  overflow-x: hidden;

  &--with-transition {
    transition: 0.4s;
  }

  &__img-box {
    display: inline-block;
    vertical-align: bottom;

    width: 100%;

    &__img {
      border-radius: 20px;
      width: 100%;
      height: 300px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}

@media screen and (min-width: $portrait) {
  .checkAll {
    margin-left: 50px;
  }
  .carousel-box {
    &__img-box {
      &__img {
        height: 180px;
      }
    }
  }
}

@media screen and (min-width: $tablet) {
  .c-prev-next-arrows {opacity: 1;}
  .title-wrap {
  &__step {
    width: 148px;
    display: flex !important;
  }
}
  .more-carousel {
    &--is-home {
      .carousel-box {
        &__img-box {
          &__img {
            height: 230px;
          }
        }
      }
    }
  }

  .carousel-box {
    &__img-box {
      &__img {
        height: 174px;
      }
    }
  }
}
</style>

<style lang="scss">
.checkAll {
  margin-left: 3px;
}
.re-carousel {
  .swiper {
    padding-bottom: 30px;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin-left: 10px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .swiper-pagination-bullet-active {
    // background-color: #f9db4a;
  }
}

.arrow {
  @include inline-flex(center);
  @include font-style(rgba($c-main, 0.5), 16, 400, 1.6px);
  outline: 0px transparent;
  border: 0px transparent;
  background-color: $c-main-yellow;
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 25px;

  &:hover {
    color: $c-main;
    opacity: 1;
    color: $c-main;
    opacity: 1;
    background-color: $c-main-yellow;
  }

  &--active {
    color: $c-main;
    opacity: 1;
    background-color: $c-main-yellow;
  }

}
</style>
